import { useTranslation } from 'react-i18next';
import PublicLayout from './PublicLayout';

export default function TermsPage() {
  const { t } = useTranslation();

  return (
    <PublicLayout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">{t('terms.title')}</h1>
        <p className="text-gray-500 mb-12">{t('terms.lastUpdated')}</p>

        <div className="prose prose-lg max-w-none space-y-8">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('terms.section1Title')}</h2>
            <p className="text-gray-600 leading-relaxed">{t('terms.section1Text')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('terms.section2Title')}</h2>
            <p className="text-gray-600 leading-relaxed">{t('terms.section2Text')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('terms.section3Title')}</h2>
            <p className="text-gray-600 leading-relaxed mb-3">{t('terms.section3Intro')}</p>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-start gap-2"><span className="text-red-500 mt-1">&#8226;</span> {t('terms.section3Item1')}</li>
              <li className="flex items-start gap-2"><span className="text-red-500 mt-1">&#8226;</span> {t('terms.section3Item2')}</li>
              <li className="flex items-start gap-2"><span className="text-red-500 mt-1">&#8226;</span> {t('terms.section3Item3')}</li>
              <li className="flex items-start gap-2"><span className="text-red-500 mt-1">&#8226;</span> {t('terms.section3Item4')}</li>
              <li className="flex items-start gap-2"><span className="text-red-500 mt-1">&#8226;</span> {t('terms.section3Item5')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('terms.section4Title')}</h2>
            <p className="text-gray-600 leading-relaxed">{t('terms.section4Text')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('terms.section5Title')}</h2>
            <p className="text-gray-600 leading-relaxed">{t('terms.section5Text')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('terms.section6Title')}</h2>
            <p className="text-gray-600 leading-relaxed">{t('terms.section6Text')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('terms.section7Title')}</h2>
            <p className="text-gray-600 leading-relaxed">{t('terms.section7Text')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('terms.section8Title')}</h2>
            <p className="text-gray-600 leading-relaxed">{t('terms.section8Text')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{t('terms.section9Title')}</h2>
            <p className="text-gray-600 leading-relaxed">
              {t('terms.section9Text')}{' '}
              <a href="mailto:legal@ai-ia.dev" className="text-blue-600 hover:underline">legal@ai-ia.dev</a>
            </p>
          </section>
        </div>
      </div>
    </PublicLayout>
  );
}
